import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setPcsReasonOptions } from '../store/options.actions'

export function* getPcsReasonOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getPcsReasonOptions])
    const { entity } = response
    yield put(setPcsReasonOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setPcsReasonOptions() error: ${e}`))
  }
}

export function* getPcsReasonOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPcsReasonOptions)
}
